

export const theadStyles = {
  background: 'whitesmoke',
  borderLeft: '1px solid #eceeef',
  borderRight: '1px solid #eceeef',
  borderRadius: '3px'
};

export const trStyles = (color) => {
  return {
    padding: '0',
    backgroundColor: color
  };
};

export const linkStyles = {
  color: 'inherit'
};
